import React, { useContext, useMemo } from 'react'
import * as locales from 'date-fns/locale'
import { DefaultInput } from './styles'
import { dateToPFormat } from '../helpers'
import { SxProps } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { DatePickerContext } from '../DatePickerProvider'

export interface IAnchorFieldProps {
  startDate?: Date | null | undefined
  endDate?: Date | null | undefined
  locale: string
  isdate: boolean
  inputSize?: 'small' | 'large'
  placeholder: string
  helpertext?: string
  onReset?: () => void
  sx?: SxProps
  hasError?: boolean
}

export default function AnchorField({
  startDate = new Date(),
  endDate = null,
  locale,
  isdate,
  inputSize = 'small',
  placeholder,
  hasError = false,
  ...props
}: IAnchorFieldProps) {
  const { t } = useTranslation()
  const { watch } = useFormContext()
  const { showPresetLabel } = useContext(DatePickerContext)

  const value = useMemo(() => {
    const presetSelection = watch('presetSelection')

    if (showPresetLabel && presetSelection) {
      return t(`datepicker.presets.${presetSelection}`)
    }

    const pStartDate = startDate
      ? dateToPFormat(startDate, locales[locale])
      : null
    const pEndDate = endDate ? dateToPFormat(endDate, locales[locale]) : null

    if (!startDate && !endDate) {
      return placeholder
    }
    if (!endDate) {
      return pStartDate
    }
    return `${pStartDate} - ${pEndDate}`
  }, [startDate, endDate, showPresetLabel, watch('presetSelection'), placeholder, locale])

  return (
    <DefaultInput
      value={value}
      autoComplete="off"
      isDate={isdate}
      inputSize={inputSize}
      readOnly={true}
      sx={{ ...props.sx, minWidth: '220px' }}
      placeholder={placeholder}
      hasError={hasError}
      {...props}
    />
  )
}
